import React, { useEffect, useState } from 'react';
import CustomerHeader from './CustomerHeader';
import CustomerTab from './CustomerTab';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import { getCustomer, getMatrixCustomer, getTicketCustomer, patchUpdateCustomer } from 'redux/actions/UserCustomer';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { filterdataCustomer } from './CustomerTableData';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';

function CustomerView() {
  const dispatch = useDispatch();
  const {state} = useLocation();
  const { id, name, demandProfileId } = state;
  const [value, setValue] = useState('1');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(1);
  const [status, setStatus] = useState("");
  const tableData = useSelector((state) => state?.userCustomer?.userCustomer?.data);
  const matrixData = useSelector((state) => state?.userMatrixCustomer?.userMatrixCustomer?.data);
  const ticketData = useSelector((state) => state?.userTicketCustomer?.userTicketCustomer?.data);
  const customerLoader = useSelector((state) => state?.userCustomer?.loading)
  const loadermatrixData = useSelector((state) => state?.userMatrixCustomer?.loading);
  let filterData = {
    id:demandProfileId,
    page:'',
    date:'',
    status:status,
    pageSize:''
  }


  useEffect(() => {
    dispatch(getCustomer(filterData));
    dispatch(getMatrixCustomer(filterData));
    dispatch(getTicketCustomer(filterData));
  }, []);

  const handleChange = (newValue) => {
    setValue(newValue);
    if(newValue == 2){
      dispatch(getTicketCustomer(filterData));
    }else{
      dispatch(getMatrixCustomer(filterData));
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };
  const breadcrumbPaths = [
    { name: 'Customer', url: -1 },
    { name: name, url: '' },
  ];

  const onFilterChange = (val) => {
    setStatus(val)
    filterData = {...filterData, status:val.toString()}
    dispatch(getTicketCustomer(filterData));
  }

  const onRestFilter = () => {
    setStatus("")
    filterData = {...filterData, status:""}
    dispatch(getTicketCustomer(filterData));
  }

  const onClickStatusIcon = (data) => {
     
    if (data === 'Activate') {
      const profileData = {
        customerId: demandProfileId,
        id:id,
        data: {
          status: 'Active',
        },
      };
      dispatch(patchUpdateCustomer(profileData));
    }
      else if (data === 'Block') {
      const profileData = {
        customerId: demandProfileId,
        id:id,
        data: {
          status: 'Blocked',
        },
      };
      dispatch(patchUpdateCustomer(profileData));
    }
    else if (data === 'Unblock') {
      const profileData = {
        customerId: demandProfileId,
        id:id,
        data: {
          status: 'Active',
        },
      };
      dispatch(patchUpdateCustomer(profileData));
    }
  };

  //roles and permissions
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );
  const customerRoleEnum = roleAndPermissionEnum.customer;
  const accessForall = handlePermissions(
    roleAndPermissions,
    customerRoleEnum.moduleKey,
    {
      defaultAllAccess: customerRoleEnum.all,
    }
  );

  const accessForBlock = handlePermissions(
    roleAndPermissions,
    customerRoleEnum.moduleKey,
    {
      defaultAllAccess: customerRoleEnum.block,
    }
  );

  const hasViewMoreIcon = (accessForall|| accessForBlock)

  return (
    <div className='marginTop'>
      <CommonBreadCrumb paths={breadcrumbPaths} />
      <CustomerHeader 
        tableData={tableData} 
        tabName="customer"
        onClickStatusIcon={onClickStatusIcon}
        loader ={customerLoader}
        statusChange={hasViewMoreIcon}
      />
      <CustomerTab 
        className="marginTop45"
        handleChange={handleChange}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        value={value}
        page={page}
        rowsPerPage={rowsPerPage}
        matrixData={matrixData}
        ticketData={ticketData}
        filterdata={filterdataCustomer}
        onFilterChange = {onFilterChange}
        onRestFilter={onRestFilter}
        loadermatrixData={loadermatrixData}
      />
    </div>
  )
}

export default CustomerView